import { SET_RECOMMENDATIONS, REQUEST_RECOMMENDATIONS } from '../constants';

export const recommendationsReducer = (state = {}, action = {}) => {
    switch (action.type) {
        case SET_RECOMMENDATIONS:
            return {
                data: { ...state.data, ...{ [action.partNumber]: { ...state?.data?.[action.partNumber], ...action.data } } },
                loading: false,
            };

        case REQUEST_RECOMMENDATIONS:
            return {
                data: { ...state.data },
                loading: true,
            };

        default:
            return state;
    }
};

export default recommendationsReducer;
